/** 數值與格式化工具。純函式，不碰 DOM。 */

export function num(value: unknown): number | null {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

// average 的唯一來源在 shared/，後端算升降方向時也讀同一份。
export { average } from "../../shared/measure-math.js";

export function round(value: number | null, digits = 1): number | null {
  return value === null || !Number.isFinite(value) ? null : Number(value.toFixed(digits));
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function roundTo(value: number, step = 50): number {
  return Math.round(value / step) * step;
}

/** 顯示用：固定小數位，無效值顯示破折號。 */
export function fmt(value: unknown, digits = 1): string {
  return Number.isFinite(Number(value)) ? Number(value).toFixed(digits) : "—";
}

/** 顯示用：熱量取整數並加千分位。 */
export function kcal(value: number | null | undefined): string {
  return Number.isFinite(value as number)
    ? Math.round(value as number).toLocaleString("zh-TW")
    : "—";
}

export function csvEscape(value: unknown): string {
  const text = String(value ?? "");
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}
